import { SavedReportsCard } from "@/Features/SavedReports";
import { saveCasesReport } from "../../../../api";

export const CaseSavedReports = ({ reportInfo }) => (
  <SavedReportsCard reportInfo={reportInfo} saveReport={saveCasesReport} />
);

export default CaseSavedReports;
